import React from "react";
import supStyles from "../atoms/Superscript/Superscript.module.scss";

export default {
	english: {
		default: {
			headline: <>You’ve got an approach to money that’s all your own. We’re not here to judge it — we’re here to help support it. And no matter where you want to go with your money, we’ll help you get there.</>,
		},
		startsmart: {
			headline: <>Your kids are learning their own approach to money — and we’re here to help you support it. A Clear Access Banking account from Wells Fargo<a id="body-sup-1" aria-label="footnote 1" className={supStyles.bodySup} href="#fn-1" ><sup>1</sup></a> can help get them get started with tools to track spending and a lot more.</>,
		}
	},




	spanish: {
		default: {
			headline: <>Aprendiste el valor de cómo se manejaba el dinero y ahora lo haces a tu manera. En&nbsp;Wells&nbsp;Fargo respetamos tus costumbres y estamos aquí para apoyarte.</>,
		},
	}
};
